export default {
    'OPERACION_OBRA': (state, mutation) => {
        state.obra = mutation.obra
    }
}